import LICITACION_PARTICIPANTES from '@/graphql/querys/administracion/licitaciones/participantes/licitacionParticipantes.gql';
import LICITACION_APERTURA_PROPUESTA from '@/graphql/querys/administracion/licitaciones/aperturapropuestas/licitacionAperturaPropuestas.gql';
import mixFormatoEstructura from '@/helpers/mixFormatoEstructura';

export default {
  mixins: [mixFormatoEstructura],
  data() {
    return {
      tiposLicitacion: [
        { id: 1, texto: 'LICITACIÓN PÚBLICA' },
        { id: 2, texto: 'LICITACIÓN RESTINGIDA POR INVITACIÓN' },
      ],
      caracterLicitacion: [
        { id: 1, texto: 'NACIONAL' },
        { id: 2, texto: 'ESTATAL' },
      ],
      normatividadLicitacion: [
        { id: 1, texto: 'FEDERAL' },
        { id: 2, texto: 'ESTATAL' },
      ],
      calendario: [
        { id: 1, texto: 'VISITA A LA OBRA', key: 'visitaObra' },
        { id: 2, texto: 'JUNTA DE ACLARACIONES', key: 'juntaAclaraciones' },
        { id: 3, texto: 'APERTURA', key: 'aperturaPropuestas' },
        { id: 4, texto: 'FALLO', key: 'fallo' },
      ],
    };
  },
  apollo: {
    licitacionParticipantes: {
      query: LICITACION_PARTICIPANTES,
      variables() {
        return {
          idLicitacion: this.$route.params.idLicitacion,
        };
      },
    },
    licitacionAperturaPropuestas: {
      query: LICITACION_APERTURA_PROPUESTA,
      variables() {
        return {
          idLicitacion: this.$route.params.idLicitacion,
        };
      },
    },
  },
  methods: {
    formatoObjeto(objeto) {
      return this.formatoEstructura(objeto, true, true);
    },
    formatoWordLicitacion(licitacion) {
      let participantes = [];
      let buscaEvento = {};
      if (!licitacion || typeof (licitacion) !== 'object') return {};
      const licitacionMap = new Map();
      let participanteMap = new Map();
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(licitacion)) {
        switch (key) {
          case 'tipo':
            if (!value) { licitacionMap.set(key, ''); break; }
            licitacionMap.set(key, this.tiposLicitacion.find((l) => l.id === value).texto);
            break;
          case 'caracter':
            if (!value) { licitacionMap.set(key, ''); break; }
            licitacionMap.set(key, this.caracterLicitacion.find((l) => l.id === value).texto);
            break;
          case 'normatividad':
            if (!value) { licitacionMap.set(key, ''); break; }
            licitacionMap.set(key, this.normatividadLicitacion
              .find((l) => l.id === value).texto);
            break;
          case 'calendario':
            // Crear un objeto, key el nombre del evento, datos generales y participantes
            if (!value) { break; }
            // eslint-disable-next-line no-loop-func
            value.forEach((e) => {
              buscaEvento = this.calendario.find((c) => c.id === e.evento) ? this.calendario.find((c) => c.id === e.evento) : '';
              if (e.eventoTexto.toUpperCase() === buscaEvento.texto) {
                participantes = [];
                participanteMap = new Map();
                this.getListaParticipantes.forEach((p) => {
                  // eslint-disable-next-line no-restricted-syntax
                  for (const [keyP, valueP] of Object.entries(p)) {
                    if (keyP === buscaEvento.key) {
                      if (valueP !== null) {
                        switch (keyP) {
                          case 'visitaObra':
                            participanteMap.set('asistio', valueP.asistio);
                            break;
                          case 'juntaAclaraciones':
                            participanteMap.set('asistio', valueP.asistio);
                            break;
                          case 'aperturaPropuestas':
                            participanteMap.set('asistio', valueP.asistio);
                            participanteMap.set('importe', valueP.importe);
                            participanteMap.set('porcentajeIva', valueP.porcentajeIva);
                            participanteMap.set('importeIva', valueP.importeIva);
                            participanteMap.set('total', valueP.total);
                            participanteMap.set('completa', valueP.completa);
                            participanteMap.set('aceptadaRevision', valueP.aceptadaRevision);
                            participanteMap.set('pasoRevision', valueP.pasoRevision);
                            participanteMap.set('observaciones', valueP.observaciones);
                            break;
                          case 'fallo':
                            participanteMap.set('asistio', valueP.asistio);
                            participanteMap.set('ganador', valueP.ganador);
                            participanteMap.set('monto', valueP.monto);
                            participanteMap.set('observaciones', valueP.observaciones);
                            break;
                          default:
                            break;
                        }
                      } else {
                        switch (keyP) {
                          case 'visitaObra':
                            participanteMap.set('asistio', false);
                            break;
                          case 'juntaAclaraciones':
                            participanteMap.set('asistio', false);
                            break;
                          case 'aperturaPropuestas':
                            participanteMap.set('asistio', false);
                            participanteMap.set('importe', 0);
                            participanteMap.set('porcentajeIva', 0);
                            participanteMap.set('importeIva', 0);
                            participanteMap.set('total', 0);
                            participanteMap.set('completa', false);
                            participanteMap.set('aceptadaRevision', false);
                            participanteMap.set('pasoRevision', false);
                            participanteMap.set('observaciones', '');
                            break;
                          case 'fallo':
                            participanteMap.set('asistio', false);
                            participanteMap.set('ganador', false);
                            participanteMap.set('monto', 0);
                            participanteMap.set('observaciones', '');
                            break;
                          default:
                            break;
                        }
                      }
                    }
                    if (keyP === 'contratista') {
                      // eslint-disable-next-line no-restricted-syntax
                      for (const [keyC, valueC] of Object.entries(valueP)) {
                        participanteMap.set(keyC, valueC);
                      }
                    }
                  }
                  participantes.push(Object.fromEntries(participanteMap));
                });
              }
              // Agrega licitacion con todos sus datos y participantes
              licitacionMap.set(buscaEvento.key,
                {
                  fecha: e.fechaHora.substring(0, 10),
                  hora: e.fechaHora.substring(11, 16),
                  lugar: e.lugar,
                  participantes,

                });
            });

            this.calendario.forEach((e) => {
              if (!licitacionMap.has(e.key)) {
                licitacionMap.set(e.key, {
                  fecha: '',
                  hora: '',
                  lugar: '',
                  participantes: [],
                });
              }
            });
            break;
          default:
            if (!value && value !== 0) { licitacionMap.set(key, ''); break; }
            licitacionMap.set(key, value);
        }
      }
      return this.formatoObjeto(Object.fromEntries(licitacionMap));
      // return Object.fromEntries(licitacionMap);
    },
  },
  computed: {
    getListaParticipantes() {
      if (!this.licitacionParticipantes) return [];
      return this.licitacionParticipantes;
    },
    getAperturaPropuestas() {
      if (!this.licitacionAperturaPropuestas) return [];
      return this.licitacionAperturaPropuestas;
    },
  },
};
